var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M50 15A15 35 0 0 1 50 85A15 35 0 0 1 50 15",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "patha",
    d: "M0 0A15 35 0 0 1 0 70A15 35 0 0 1 0 0",
    fill: "none"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path",
    stroke: "#dfdfdf",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path",
    stroke: "#dfdfdf",
    strokeWidth: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path",
    stroke: "#dfdfdf",
    strokeWidth: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 9,
    fill: "#e15b64"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#patha"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 9,
    fill: "#f8b26a"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.16666666666666666s"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#patha"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 9,
    fill: "#abbd81"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.3333333333333333s"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#patha"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.833c7a86faf945387a17541a9143d780.svg";
export { ForwardRef as ReactComponent };